
import Form from "./Form.vue";
import { mapGetters } from "vuex";

export default {
  name: "app-conta-pagar-create",
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
